import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type SubscribeAuthScreen =
    Extract<Screen, { type: "subscribeAuth" }>;

export class SubscribeAuthScreenMapper
    implements ScreenMapper<SubscribeAuthScreen> {

    public readonly type = "subscribeAuth" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: SubscribeAuthScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "subscribeAuth"

            },

            isLoading: false

        });

    }

}